// actions created for b2b form [24-06-2024] by kiran konda
import {
  CCPA_FORM,
  CCPA_FORM_SUCCESS,
  CCPA_FORM_FAILURE
} from "redux/constants/actionTypes";

import axios from "config/axios";

export const ccpaFormDetails = (payload) => {
  return {
    type: CCPA_FORM,
    payload: payload
  };
};
export const ccpaDetailsSuccess = (payload) => {
  return {
    type: CCPA_FORM_SUCCESS,
    payload: payload
  };
};
export const ccpaDetailsFailure = (payload) => {
  return {
    type: CCPA_FORM_FAILURE,
    payload: payload
  };
};

export const ccpaDetails = (body) => async (dispatch) => {
  dispatch(ccpaFormDetails());
  axios
    .post("/AogCCPAForm", body)
    .then((res) => {
      dispatch(ccpaDetailsSuccess(res?.data));
    })
    .catch((error) => {
      dispatch(ccpaDetailsFailure({ error: error?.data?.message }));
    });
};
